module.exports = __webpack_public_path__ + "img/happy.69c61cab.jpg";